import { normalizeTooltipScaleFactor } from "../../../lib/helpers/calculateTopOffset";

export const getContrastTooltipStyles = (scaleFactor: number) => {
  const normalizedScaleFactor = normalizeTooltipScaleFactor(scaleFactor);

  if (normalizedScaleFactor === 1) {
    return {
      height: "26px",
      fontSize: "16px",
      padding: "8px 10px",
      borderRadius: "30px",
    };
  }

  if (normalizedScaleFactor === 0.85) {
    return {
      height: "20px",
      fontSize: "14px",
      padding: "6px 8px",
      borderRadius: "24px",
    };
  }

  return {
    height: "16px",
    fontSize: "11px",
    padding: "4px 6px",
    borderRadius: "16px",
  };
};

export const getContrastTooltipMarginTop = (scaleFactor: number) => {
  if (scaleFactor === 1) return "23px";
  if (scaleFactor === 0.85) return "20px";
  if (scaleFactor === 0.7) return "17px";

  return "12px";
};
